const en_common = {
    accept: "accept",
    action: "action",
    active: "active",
    active_non: "inactive",
    add: "add",
    address: "address",
    approve: "approve",
    attribute: "attribute",
    back: "back",

    bank: "bank",
    bank_acc: "bank account",

    batch: "batch",
    brand: "brand",
    label: "label",
    barcode: "barcode",

    category: "category",
    cancel: "cancel",
    choose: "choose",
    choose_img: "choose image",
    choose_file: "choose file",

    city: "city",
    close: "close",
    closing: "stock closing",
    courier: "courier",
    code: "code",
    company: "company",

    complete: "complete",
    confirmation: "confirmation",
    connected: "connected",
    created_by: "created by",

    credit: "credit",
    debit: "debit",
    deposit: 'deposit',

    customer: "customer",
    customer_type: "customer type",

    date: "date",
    date_created: "created date",
    date_due: "due date",
    date_delivery: "delivery date",
    date_start: "start date",
    date_end: "end date",
    date_pay: "payment date",
    date_range: "date range",
    date_request: "request date",
    date_transaction: "transaction date",
    date_update: "updated date",

    delete: "delete",
    delivered: "delivered",
    detail: "detail",
    description: "description",

    discount: "discount",

    district: "subdistrict",
    sub_district: "district",
    province: "province",

    difference: "difference",
    document_type: "document type",
    download_pdf: 'download PDF',

    duplicate: "duplicate",
    edit: "edit",

    email: "email",

    export_excel: "export to Excel",
    export_csv: "export to CSV",
    export_pdf: "export to PDF",

    failed: "failed",
    finish: "finish",

    fullname: "full name",

    goods: "item",
    goods_list: "item list",
    goods_name_sku: "item name / SKU",

    height: "height",
    here: "here",
    length: "length",
    width: "width",
    weight: "weight",

    history: "history",
    image: "image",

    in: "in",
    out: "out",

    info: "information",
    language: "language",
    loading: "loading...",

    location: "location",
    storage: "storage location",
    method: "method",

    name: "name",
    name_full: "full name",
    npwp: 'NPWP',

    next_month: "next month",
    prev_month: "previous month",

    no_: "no",
    no: "number",

    no_do: "DO number",
    no_delivery: "delivery number",
    no_invoice: "invoice number",
    no_itemin: "item in number",
    no_itemout: "item out number",
    no_po: "PO number",
    no_recap: "recap number",
    no_reference: "reference number",
    no_so: "SO number",
    no_transaction: "transaction number",

    note: "note",
    no_option: "no option",
    no_description: "no description",

    offer: "offer",
    paid: "paid",

    pass: "password",
    pass_conf: "confirm password",
    pass_new: "new password",
    pass_reset: "reset password",
    pass_change: "change password",

    payment: "payment",

    percentage: "percentage",
    period: "period",

    phone: "phone",
    telp: "phone",

    price: "price",
    price_buy: "buy price",
    price_sell: "sell price",
    price_retail: "retail price",

    print: "print",
    print_whs: "print for warehouse",

    process: "process",
    progress: "progress",

    profile: "profile",

    quantity: "quantity",
    quantity_sell: "sold quantity",
    qty: "qty",

    recipient: "recipient",
    sender: "sender",

    refresh: "refresh",
    reference: "reference",
    reject: "reject",
    request: "request",

    sales: "sales",

    save: "save",

    search: "search",
    select_all: "select all",

    serial_num: "serial number",
    sku: "SKU",

    success: "success",

    supplier: "supplier",
    supplier_type: "supplier type",

    status: "status",
    status_delivery: "delivery status",

    stock: "stock",
    stock_init: "initial stock",

    tier: "tier",
    to: "to",

    type: "type",
    unit: "unit",

    upload: "upload",
    user: "user",

    warehouse: "warehouse",
    warehouse_orig: "origin warehouse",
    warehouse_dest: "destination warehouse",

    verification: "verification",
    yes: "yes"
}

export default en_common